import React, { useState } from 'react';
import {
  Box,
  ClickAwayListener,
  List,
  ListItem,
  Popper,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  Modal,
  Button,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ClearIcon from '@mui/icons-material/Clear';

const inputStyle = {
  height: '46px',
  backgroundColor: '#fff',
  fontSize: '13px',
};

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 600,
  width:'100%',
  bgcolor: '#fff',
  borderRadius: '10px',
  boxShadow: 24,
  border: '4px solid #00AAE7',
  pt: 3,
};

const CustomDepartmentSelect = ({
  // inputStyle,
  searchBox = true,
  showAddOption = true,
  initialOptions = [],
  addButtonLabel = '+ Add Department',
  modalTitle = 'Add Department',
  modalSubTitle,
  modalInputTitle,
  modalPlaceholder = 'Enter Department Name',
  selectedPlaceholder,
  modalInputValue, // optional controlled input
  onModalInputChange, // optional change handler
  modalSearchplaceHolder,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState('');
  const [options, setOptions] = useState(initialOptions);
  const [filteredOptions, setFilteredOptions] = useState(initialOptions);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [newDepartment, setNewDepartment] = useState('');

  const handleToggle = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setSearch('');
    setFilteredOptions(options);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    setFilteredOptions(
      options.filter((option) =>
        option.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const handleSelect = (value) => {
    setSelectedDepartment(value);
    setAnchorEl(null);
  };

  const handleAddDepartment = () => {
    setAnchorEl(null);
    setOpenModal(true);
  };

  const handleSaveDepartment = () => {
    if (newDepartment.trim()) {
      const updated = [...options, newDepartment.trim()];
      setOptions(updated);
      setFilteredOptions(updated);
      setSelectedDepartment(newDepartment.trim());
    }
    setNewDepartment('');
    setOpenModal(false);
  };

  const handleCancelModal = () => {
    setNewDepartment('');
    setOpenModal(false);
  };


  return (
    <>
      <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
        <Box>
          <TextField
            fullWidth
            variant="outlined"
            placeholder={selectedPlaceholder}
            value={selectedDepartment}
            onClick={handleToggle}
            InputProps={{
              readOnly: true,
              sx: inputStyle,
              endAdornment: (
                <InputAdornment position="end">
                  {selectedDepartment && (
                    <IconButton
                      edge="end"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedDepartment('');
                      }}
                      sx={{ mr: 0.5 }}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  )}
                  <IconButton edge="end" size="small" onClick={handleToggle}>
                    <KeyboardArrowDownIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Popper
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            placement="bottom-start"
            disablePortal
            modifiers={[
              {
                name: 'preventOverflow',
                options: {
                  boundary: 'viewport',
                  padding: 8,
                },
              },
              {
                name: 'offset',
                options: {
                  offset: [0, 8],
                },
              },
            ]}
            sx={{
              zIndex: 1300,
              width: anchorEl ? anchorEl.offsetWidth : 300,
            }}
          >
            <Box
              sx={{
                bgcolor: '#fff',
                borderRadius: '10px',
                boxShadow: 3,
                position: 'relative',
              }}
            >
              {/* Search Box */}
              {searchBox && (
              <Box
                sx={{
                  margin: '0 10px',
                  padding: '10px 0',
                  borderBottom: '1px solid #D9D9D9',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    background: '#fff',
                    border: '1px solid #E5E8EB',
                    borderRadius: '50px',
                    px: 2,
                    py: 0,
                    zIndex: 2,
                  }}
                >
                  <SearchIcon sx={{ color: '#A0A0A0', mr: 1 }} />
                  <input
                    type="text"
                    value={search}
                    onChange={handleSearchChange}
                    placeholder={modalSearchplaceHolder}
                    style={{
                      border: 'none',
                      outline: 'none',
                      flex: 1,
                      height: '36px',
                      fontSize: '12px',
                      backgroundColor: 'transparent',
                    }}
                  />
                </Box>
              </Box>
              )}

              {/* List */}
              <Box sx={{ flexGrow: 1, overflowY: 'auto', px: 1, maxHeight: 200 }}>
                <List dense>
                  {filteredOptions.map((option, index) => (
                    <ListItem
                      key={index}
                      onClick={() => handleSelect(option)}
                      sx={{
                        fontSize: '12px',
                        cursor: 'pointer',
                        px: 2,
                        py: 1,
                        '&:hover': {
                          backgroundColor: '#F5F7FA',
                          color: '#0076FE',
                        },
                      }}
                    >
                      {option}
                    </ListItem>
                  ))}
                </List>
              </Box>

              {/* Footer */}
              {showAddOption && (
                <Box
                  sx={{
                    borderTop: '1px solid #eee',
                    px: 2,
                    py: 1,
                    cursor: 'pointer',
                    color: '#0076FE',
                    fontSize: '14px',
                    fontWeight: 500,
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                    background: '#fff',
                    zIndex: 2,
                  }}
                  onClick={handleAddDepartment}
                >
                  {addButtonLabel}
                </Box>
              )}
            </Box>
          </Popper>
        </Box>
      </ClickAwayListener>

      {/* Modal */}
 <Modal open={openModal} onClose={handleCancelModal}>
  <Box
    sx={{
      ...modalStyle,
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '90vh',
      overflow: 'hidden', // prevents outer scrollbars
    }}
  >
    {/* Header */}
    <Box sx={{ mb: 2, borderBottom:'1px solid #DFDFDF', pb:2,  px: 3, }}>
      <Typography sx={{ fontSize: '18px', fontWeight: 600, color:'#1A1F36', }}>
        {modalTitle}
      </Typography>
      <Typography sx={{ fontSize: '12px', color: '#64748B', fontWeight: 400 }}>
        {modalSubTitle}
      </Typography>
    </Box>

    {/* Scrollable Body */}
    <Box
      sx={{
        flex: 1,
        overflowY: 'auto',
        minHeight:'150px',
        mb: 3, 
        px: 3,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          marginBottom: '4px',
          fontWeight: 600,
          color: '#1A1A1A',
          fontSize: '14px',
        }}
      >
        {modalInputTitle}
      </Typography>

      <TextField
        fullWidth
        placeholder={modalPlaceholder}
        value={modalInputValue !== undefined ? modalInputValue : newDepartment}
        onChange={(e) => {
          const value = e.target.value;
          if (onModalInputChange) {
            onModalInputChange(value);
          } else {
            setNewDepartment(value);
          }
        }}
        variant="outlined"
        InputProps={{
          sx: inputStyle,
        }}
      />

      {/* Optional: Add more scrollable content below if needed */}
    </Box>

    {/* Footer */}
    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, p: 3, background:'#F2F6F9', borderTop:'1px solid #DFDFDF' }}>
      <Button
        variant="outlined"
        onClick={handleCancelModal}
        sx={{
          fontSize: '14px',
          borderRadius: '5px',
          borderColor: '#9095A1',
          color: '#9095A1',
        }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={handleSaveDepartment}
        sx={{
          fontSize: '14px',
          borderRadius: '5px',
          backgroundColor: '#0076FE',
        }}
      >
        Save
      </Button>
    </Box>
  </Box>
</Modal>


    </>
  );
};

export default CustomDepartmentSelect;
